const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

let initialized = false;

export const isGoogleAnalyticsEnabled = () => Boolean(GA_MEASUREMENT_ID);

export const initGoogleAnalytics = () => {
	if (!isGoogleAnalyticsEnabled() || initialized || typeof window === 'undefined') {
		return;
	}

	initialized = true;

	window.dataLayer = window.dataLayer || [];
	window.gtag = function gtag() {
		window.dataLayer.push(arguments);
	};

	window.gtag('js', new Date());
	window.gtag('config', GA_MEASUREMENT_ID, {
		send_page_view: false,
	});

	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
	document.head.appendChild(script);
};

export const trackPageView = (path, title) => {
	if (!isGoogleAnalyticsEnabled() || typeof window === 'undefined' || !window.gtag) {
		return;
	}

	window.gtag('event', 'page_view', {
		page_path: path,
		page_title: title || document.title,
	});
};

export const trackEvent = (eventName, params = {}) => {
	if (!isGoogleAnalyticsEnabled() || typeof window === 'undefined' || !window.gtag) {
		return;
	}

	window.gtag('event', eventName, params);
};
